module.exports = __webpack_public_path__ + "img/rabbit.66184faa.svg";